import { MediaFolder } from 'src/app/core/models/library';

export const MAX_LIBRARY_FOLDER_DEPTH = 25;

export function countFolderResources(
  folder: MediaFolder,
  depth = 0,
  maxDepth = MAX_LIBRARY_FOLDER_DEPTH,
): number {
  if (depth >= maxDepth) {
    return Math.max(folder.Resources?.length ?? 0, folder.ResourceCount ?? 0);
  }

  const directResources = Math.max(folder.Resources?.length ?? 0, folder.ResourceCount ?? 0);
  const nestedResources = folder.SubFolders?.reduce(
    (total, subfolder) => total + countFolderResources(subfolder, depth + 1, maxDepth),
    0,
  ) ?? 0;

  return directResources + nestedResources;
}
